/**
 * Centralized role check — kept in sync with the backend role taxonomy
 * exposed at GET /api/users/roles. Every role here should have access to
 * the Dealer Portal at /dealer.
 */
export const DEALER_ROLES = new Set([
  // Legacy / historical role keys (still in DB on some accounts)
  "dealer", "gm", "manager", "assistant",
  // Current 11-role taxonomy
  "owner", "super_admin", "admin", "sales_manager",
  "salesperson", "bdc", "fni", "service",
  "inventory", "marketing", "auditor",
  // "guest" is intentionally excluded — guests get limited customer-side view only
]);

export function isDealerUser(user) {
  return !!(user && DEALER_ROLES.has(user.role));
}

export function isOwner(user) {
  return !!(user && (user.role === "owner" || user.role === "super_admin" || user.role === "dealer"));
}
